export const CloseIcon = ({ color = "#8D8D8D", size = 14, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M16.0003 1.17396L14.3888 -0.4375L8.00015 5.95119L1.61146 -0.4375L0 1.17396L6.38869 7.56265L0 13.9513L1.61146 15.5628L8.00015 9.17411L14.3888 15.5628L16.0003 13.9513L9.61161 7.56265L16.0003 1.17396Z" fill={color} />
    </svg>

);
